module.exports = __webpack_public_path__ + "static/media/equal-ages.1210cba1.png";